module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_1_1.679e3f50.png";